<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-8">
          <h5 class="card-title">
            <a class="text-dark" :href="base_url + 'pro/cotizacion_invitado/' + s.id_mm">
              Mudanza {{ s.ambito }} de {{ s.m3 }}m<sup>3</sup>
            </a>
          </h5>
          <div class="row mb-3">
            <div class="col-md-2">
              <span class="text-info">
                <b>Para: </b>
              </span>
            </div>
            <div class="col-12 col-md-10">
              <span class="text-muted">
                {{ moment(s.fecha_requerida).format("DD/MM/YYYY") }}
              </span>
              <span v-if="s.fecha_requerida == moment().format('YYYY-MM-DD')" class="text-muted">para hoy</span>
              <span v-else class="text-muted">{{ moment(s.fecha_requerida).fromNow() }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 text-info">
              <b>De:</b>
            </div>
            <div class="col-md-10">
              <em v-if="s.inmueble_origen" class="text-primary">{{ s.inmueble_origen.descripcion }}</em> -
              {{ s.dir_origen }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 text-info">
              <b>Hacia:</b>
            </div>
            <div class="col-md-10">
              <em v-if="s.inmueble_destino" class="text-primary">{{ s.inmueble_destino.descripcion }}</em> -
              {{ s.dir_destino }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 text-info">
              <b>ID:</b>
            </div>
            <div class="col-md-10">
              <span class="text-muted">{{ s.id_mm }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-12">
                  <span
                    v-if="s.descuento_solicitud.precio_promocion > 0"
                    class="badge badge-danger"
                    title="Nuestras asesoras no han tenido contacto con el cliente, aprovecha el descuento de preventa"
                  >
                    Pre-Venta
                  </span>
                  <span
                    v-else
                    class="badge badge-success"
                    title="Nuestras asesoras ya han tenido contacto con el cliente y verificado la solciitud"
                  >
                    Cliente verificado
                  </span>
                  <span
                    v-if="s.cliente_frecuente && s.cliente_frecuente.correo"
                    class="badge badge-warning"
                    title="Este cliente ha contratado en el pasado con Mejores Mudanzas"
                  >
                    Cliente frecuente
                  </span>
                  <span
                    v-if="s.via_contacto == 'landing_pages_compartidas'"
                    class="badge"
                    title="Este cliente se interesa en un servicio de mudanza compartida"
                    style="background: #7022b3; color: white;"
                  >Compartida</span>
                  <span
                    v-else-if="s.via_contacto == 'landing_pages_economicas'"
                    class="badge badge-info"
                    title="Este cliente se interesa en un servicio de mudanza economica"
                  >
                    Económica
                  </span>
                  <span
                    v-if="s.numero_cotizaciones == 0"
                    class="badge badge-info"
                    title="Se el primero en cotizar y ganate a este cliente que aún no recibe cotizaciones"
                  >
                    Ser el primero
                  </span>
                </div>
                <div class="col-12">
                  <span class="small" style="color: #9b9b9b;">
                    Publicada
                    {{ moment(s.fecha_liberacion).fromNow() }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <a class="btn btn-warning text-white" :href="base_url + 'pro/cotizacion_invitado/' + s.id_mm">
            Ver detalles
            <i class="fas fa-angle-right"></i>
          </a>
          <h5 class="display-4 mt-4" style="font-size: 2.25rem;">
            $
            <span v-if="s.descuento_solicitud.precio_promocion > 0">
              {{ s.descuento_solicitud.precio_promocion }}
            </span>
            <span v-else>{{ s.precio_m4 }}</span>
            <span style="font-size: 18px;"> MXN</span>
          </h5>
          <span
            v-if="s.descuento_solicitud.precio_promocion > 0"
            class="display-4 mt-4"
            style="font-size: 1.25rem; text-decoration: line-through;"
          >
            ${{ s.precio_m4 }} MXN
          </span>
          <br />
        </div>
      </div>
      <div v-if="s.preocupacion_cliente" class="row">
        <div class="col-12 mt-3">
          <div class="alert alert-warning m-0" role="alert">
            <ul class="list-unstyled mb-0">
              <li><b>Nota importante</b></li>
              <li>
                <small>{{ s.preocupacion_cliente }}</small>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    s: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      base_url
    };
  }
};
</script>
